/**
 * Drapeau legacy porté par les routes supports-tunnels et garanties-tunnels.
 *
 * L'écran de gestion de tunnel de l'ancien back-office le passait systématiquement à
 * `false`, quel que soit le produit — y compris sur les tunnels GLI. On conserve ce
 * comportement à l'identique : le basculer changerait le jeu de données retourné par le
 * back et sort du périmètre de la reprise.
 */
export const IS_TUNNEL_GLI = false;
